import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServiciosPage = lazy(() => import('../pages/servicios/page'));
const ProyectosPage = lazy(() => import('../pages/proyectos/page'));
const QuizPage = lazy(() => import('../pages/quiz/page'));
const PresupuestoPage = lazy(() => import('../pages/presupuesto/page'));
const SobrePage = lazy(() => import('../pages/sobre/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ContactoPage = lazy(() => import('../pages/contacto/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/servicios',
    element: <ServiciosPage />,
  },
  {
    path: '/proyectos',
    element: <ProyectosPage />,
  },
  {
    path: '/quiz',
    element: <QuizPage />,
  },
  {
    path: '/presupuesto',
    element: <PresupuestoPage />,
  },
  {
    path: '/sobre',
    element: <SobrePage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/contacto',
    element: <ContactoPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;